import { AlertColor } from '@mui/material'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '.'

export interface IProfileSlice {
  status: string
  shouldOpen: boolean
  message: string | undefined
  severity: AlertColor | undefined
}

const initialState: IProfileSlice = {
  status: 'idle',
  shouldOpen: false,
  message: undefined,
  severity: undefined,
}

export const leaderboardSlice = createSlice({
  name: 'leaderboard',
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.shouldOpen = action.payload
    },
    setMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload
    },
    setSeverity: (state, action: PayloadAction<AlertColor>) => {
      state.severity = action.payload
    },
    clearData: () => initialState,
  },
})

export const selectIsLoading = (state: RootState): boolean =>
  state.leaderboard.status === 'loading'
export const selectShouldOpen = (state: RootState): boolean =>
  state.leaderboard.shouldOpen
export const selectMessage = (state: RootState): string | undefined =>
  state.leaderboard.message
export const selectSeverity = (state: RootState): AlertColor | undefined =>
  state.leaderboard.severity

export const { setOpen, setMessage, setSeverity, clearData } =
  leaderboardSlice.actions

export default leaderboardSlice.reducer
